import React from "react";
import Cropper from "react-easy-crop";
import { Box, IconButton, Slider, Stack, Typography } from "@mui/material";
import RotateLeftOutlinedIcon from "@mui/icons-material/RotateLeftOutlined";
import RotateRightOutlinedIcon from "@mui/icons-material/RotateRightOutlined";
import ZoomInOutlinedIcon from "@mui/icons-material/ZoomInOutlined";
import ZoomOutOutlinedIcon from "@mui/icons-material/ZoomOutOutlined";

import { Locale } from "../../../../assets/Locale";

const clamp = (value, min, max)=>Math.min(max, Math.max(min, value));

export const AvatarEditor = (props)=>{
    const {
        crop,
        imageUrl,
        onCropChange,
        onCropComplete,
        onRotationChange,
        onZoomChange,
        rotation,
        zoom
    } = props;
    const say = Locale.use();

    const changeZoom = (_event, value)=>{
        onZoomChange(value);
    };

    const changeRotation = (_event, value)=>{
        onRotationChange(value);
    };

    const nudgeZoom = value=>{
        onZoomChange(clamp(zoom + value, 1, 4));
    };

    const nudgeRotation = value=>{
        onRotationChange(clamp(rotation + value, -180, 180));
    };

    return (
        <Box className="AvatarForm-editor">
            <Box className="AvatarForm-cropper">
                <Cropper
                    aspect={1}
                    crop={crop}
                    cropShape="round"
                    image={imageUrl}
                    onCropChange={onCropChange}
                    onCropComplete={onCropComplete}
                    onZoomChange={onZoomChange}
                    rotation={rotation}
                    showGrid
                    zoom={zoom}
                />
            </Box>
            <Box className="AvatarForm-controls">
                <Stack className="AvatarForm-controlRow" direction="row">
                    <Typography className="AvatarForm-controlLabel">{say("profileAvatarControlZoom")}</Typography>
                    <IconButton className="AvatarForm-iconButton" onClick={_=>nudgeZoom(-.1)} type="button">
                        <ZoomOutOutlinedIcon />
                    </IconButton>
                    <Slider
                        aria-label={say("profileAvatarControlZoomAria")}
                        className="AvatarForm-slider"
                        max={4}
                        min={1}
                        onChange={changeZoom}
                        step={.01}
                        value={zoom}
                    />
                    <IconButton className="AvatarForm-iconButton" onClick={_=>nudgeZoom(.1)} type="button">
                        <ZoomInOutlinedIcon />
                    </IconButton>
                </Stack>
                <Stack className="AvatarForm-controlRow" direction="row">
                    <Typography className="AvatarForm-controlLabel">{say("profileAvatarControlRotate")}</Typography>
                    <IconButton className="AvatarForm-iconButton" onClick={_=>nudgeRotation(-90)} type="button">
                        <RotateLeftOutlinedIcon />
                    </IconButton>
                    <Slider
                        aria-label={say("profileAvatarControlRotateAria")}
                        className="AvatarForm-slider"
                        max={180}
                        min={-180}
                        onChange={changeRotation}
                        step={1}
                        value={rotation}
                    />
                    <IconButton className="AvatarForm-iconButton" onClick={_=>nudgeRotation(90)} type="button">
                        <RotateRightOutlinedIcon />
                    </IconButton>
                </Stack>
            </Box>
        </Box>
    );
};
